import { render, staticRenderFns } from "./PanelImage.vue?vue&type=template&id=510147d3"
import script from "./PanelImage.vue?vue&type=script&lang=js"
export * from "./PanelImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports